import { debugLogger } from '@/utils/debugLogger';

interface ProfileCacheData {
  userId: string;
  profileData: any;
  timestamp: number;
}

export class ProfileCacheService {
  private static instance: ProfileCacheService;
  private readonly CACHE_KEY = 'user_profile_data';
  private readonly CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 hours

  static getInstance(): ProfileCacheService {
    if (!ProfileCacheService.instance) {
      ProfileCacheService.instance = new ProfileCacheService();
    }
    return ProfileCacheService.instance;
  }

  saveProfileData(userId: string, profileData: any): void {
    try {
      const data: ProfileCacheData = {
        userId,
        profileData,
        timestamp: Date.now()
      };
      localStorage.setItem(this.CACHE_KEY, JSON.stringify(data));
      debugLogger.debug('ProfileCacheService', 'Data saved for user', { userId });
    } catch (error) {
      debugLogger.error('ProfileCacheService', 'Error saving data', error);
    }
  }

  getProfileData(userId: string): any | null {
    try {
      const item = localStorage.getItem(this.CACHE_KEY);
      if (!item) return null;

      const data: ProfileCacheData = JSON.parse(item);
      
      // Verificar se é do usuário correto
      if (data.userId !== userId) {
        this.clearProfileData();
        return null;
      }

      // Verificar se não expirou
      if (Date.now() - data.timestamp > this.CACHE_DURATION) {
        this.clearProfileData();
        return null;
      }

      return data.profileData;
    } catch (error) {
      debugLogger.error('ProfileCacheService', 'Error getting data', error);
      this.clearProfileData();
      return null;
    }
  }

  clearProfileData(): void {
    try {
      localStorage.removeItem(this.CACHE_KEY);
      debugLogger.debug('ProfileCacheService', 'Data cleared');
    } catch (error) {
      debugLogger.error('ProfileCacheService', 'Error clearing data', error);
    }
  }

  hasValidCache(userId: string): boolean {
    return this.getProfileData(userId) !== null;
  }
}

export const profileCacheService = ProfileCacheService.getInstance();
